module.exports = __webpack_public_path__ + "img/67.c1763dd.jpg";